// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3jxWy","active":"NavigationItem_active__3vuQN"};